import React, { useState, useRef, useEffect } from "react";
import { AiOutlineSend } from "react-icons/ai";
import SuggestionCard from "./SuggestionCard";
import { input } from "@material-tailwind/react";
import axios from "axios";

const InputQuesComponent = ({
  fetchGptResponse,
  currentSuggestion,
  subtitle,
}) => {
  const [data, setData] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [iconColor, setIconColor] = useState("#999999");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [uuid, setUuid] = useState("");

  const textAreaRef = useRef(null);

  const handleInputChange = (inputValue) => {
    // Clear the previous timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after a delay (e.g., 500ms)
    const newTimeout = setTimeout(() => {
      fetchData(inputValue);
    }, 500);

    setTypingTimeout(newTimeout);

    setInputQuery(inputValue);

    if (inputValue.length > 0) {
      setIconColor("#174ae4");
    } else {
      setIconColor("#999999");
    }
  };

  const fetchData = async (input) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}api/gptcomplete`,
        {
          q: input,
          ln: "en",
        }
      );
      const data = await response.data;
      console.log(data);
      setData(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    handleInputChange(inputQuery);
  }, [inputQuery]);

  useEffect(() => {
    textAreaRef.current.style.height = "auto";
    textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
  }, [inputQuery]);

  function handleSendRequest() {
    fetchGptResponse(inputQuery, uuid);
    setInputQuery("");
    setUuid("");
  }

  useEffect(() => {
    setInputQuery(currentSuggestion);
  }, [currentSuggestion]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevents the addition of a new line in the text field (not needed in a lot of cases)
      handleSendRequest();
    }
  };
  return (
    <div className="flex flex-col h-24 z-50 bg-white ">
      <div className="md:w-[80%] w-[90%] mx-auto border border-gray-400 md:mt-4 mb-2 md:mb-0 flex flex-row md:rounded-2xl rounded-xl shadow-xl relative">
        <input
          type="text"
          ref={textAreaRef}
          className="md:w-[95%] w-[90%] bg-white md:px-3 px-2 py-1 my-1 mx-1 rounded-lg text-black resize-none focus:outline-none overflow-y-hidden relative bottom-0"
          name="inputquery"
          id="inputquery"
          rows="1"
          placeholder="Ask me Anything.."
          value={inputQuery}
          onKeyDown={handleKeyPress}
          onChange={(e) => handleInputChange(e.target.value)}
        />
        <div className="md:pl-4 md:w-[5%] w-[10%] px-2 relative">
          <AiOutlineSend
            className="absolute bottom-2 mb-0 fill-current hover:cursor-pointer"
            size={20}
            onClick={handleSendRequest}
            style={{ fill: iconColor }}
          />
        </div>
      </div>
      <div className="flex justify-center items-center h-7 sm:h-auto left-0 md:w-[80%] w-[90%] mx-auto mb-4">
        <>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <div
                className="mx-1 my-1 cursor-pointer w-1/3"
                key={index}
                onClick={() => {
                  setInputQuery(item.title);
                  setUuid(item.uuid);
                  setIconColor("#174ae4");
                  {
                    document.getElementById("inputquery").focus();
                  }
                }}
              >
                <SuggestionCard suggestion={item.title} />
              </div>
            ))
          ) : (
            <div
              className="text-gray-500 font-montserrat text-xs font-normal text-center md:mt-2 mt-2"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            ></div>
          )}
        </>
      </div>
    </div>
  );
};

export default InputQuesComponent;
